<template>
  <TransitionRoot as="template" :show="open">
    <Dialog as="div" class="relative z-50" @close="closeClicked">
      <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
        <div class="fixed inset-0 hidden bg-gray-700 backdrop-blur-3xl bg-opacity-75 transition-opacity " />
      </TransitionChild>

      <DialogPanel
          class="fixed inset-0 flex items-center justify-center h-lvh z-50"
          style="background-color: var(--theme-modal-bg, rgba(0,0,0,0.9)); backdrop-filter: var(--theme-modal-blur, blur(64px));"
      >
        <button type="button" class="absolute right-4 top-4 bg-white hover:bg-gray-400 z-30 rounded-full hover:text-white sm:right-6 sm:top-8 lg:right-8 lg:top-8" @click="closeClicked">
          <span class="sr-only">Close</span>
          <XMarkIcon class="h-6 w-6" aria-hidden="true" />
        </button>
        <div class="max-w-full max-h-full w-full h-full flex items-center justify-center p-6">
          <SlideShow :slides="slides" :cover="false" :initial-index="currentIndex" />
        </div>
      </DialogPanel>
    </Dialog>
  </TransitionRoot>
</template>

<script setup>
import {ref, defineExpose, defineProps, computed, onMounted} from 'vue'
import {
  Dialog,
  DialogPanel,

  TransitionChild,
  TransitionRoot,
} from '@headlessui/vue'
import { XMarkIcon } from '@heroicons/vue/24/outline'
import {resolveMediaUrl, resolveVideo} from "@/composables/images.js";
import CarouselPanel from "@/components/CarouselPanel.vue";
import SlideShow from "@/components/SlideShow.vue";


const props = defineProps({
  imageUrl: {
    type: String,
    required: false,
  },
  videoUrl: {
    type: String,
    required: false,
  },
  mediaType: {
    type: String,
    default: 'image',
  },
  name: String,
  frosted: {
    type: Boolean,
    default: false
  },
  items: {
    type: Array,
    default: () => []
  },
  initialIndex: {
    type: Number,
    default: 0
  }
})

const emit = defineEmits(["closed"]);

const currentIndex = ref(props.initialIndex)
const items = ref(props.items)
const hasList = computed(() => items.value && items.value.length > 0)
const slides = ref([])


onMounted(() => {
  if (props.videoUrl) {
    slides.value.push({type: props.mediaType,  url: props.videoUrl})
  }
  else if (props.imageUrl) {
    slides.value.push({type: props.mediaType,  url: props.imageUrl})
  }
  else {
    slides.value.push(...props.items)
  }




})

function openBox(list = null, index = 0) {
  if (list && list.length) {
    items.value = list
    currentIndex.value = index
  }
  open.value = true
}

const closeBox = () => {
  open.value = false
}

const closeClicked = () => {
  emit('closed')
  closeBox()
}

defineExpose({ openBox, closeBox })


const frostedStyle = computed(() => {
  if (props.frosted) {
    return {
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      backdropFilter: 'blur(20px)',
      color: 'white'
    };
  }
  return {
    backgroundColor: 'black',
  };
});


const open = ref(false)
</script>